/** API route map: URLS.Controller.Candidate */
export const Candidate = {
      Name: 'Candidate/',
      GetAll: 'candidates',
      GetAllTabCounts: 'get-tab-counts',
      AddClient: 'add-candidate',
      AddPath: 'get-path-candidate',
      Patch: 'patch',
      PatchStatus: 'patch-status',
      Tiles: 'tiles',
      ProfileSummary: 'summary',
      Information: 'info',
      GetAllCandidateExport: 'candidates-export',
      GetBadgesUsingCandidate: 'get-badges-using-candidate',
      GetBadgesForBulk: 'get-badges-for-bulk',
      AddBadgesBulk: 'add-bulk-badge',
      AddBulkJobs: 'add-bulk-jobs',
      AddCandidateResumeParser: 'add-candidateresumeparser',
      AddBulkBadgeCandidates: 'add-bulk-badge-candidates',
      AddOnboardingBulkCandidates: 'add-onboarding-bulk-status-candidates',
      GetAssessmentforms: 'get-assessment-forms',
      AddAssignAssessmentform: 'add-assign-assessment-form',
      GetAllAssignedAssessmentform: 'get-all-assigned-assessment-form',
      AddAssignAssessmentFormCandidates: 'add-assign-assessment-form-candidates',
      GetCandidateLogs: 'get-candidate-logs',
      UpdateCandidateProfileImage: 'update-candidate-profile-image',
      UpdateStatus: 'update-candidate-status',
      ChangeCandidateStatusAgainstJob: 'change-candidate-status-against-job',
      UpdateHiredCandidateSalaryDetail: 'update-hired-candidate-salary-detail',
      ResendAssignAssessmentform: 'resend-assign-assessment-form',
      CandidateOfferLetterEmail: 'candidates-offer-letter-email',
      GetAllCandidateOfferLetter: 'get-all-candidate-offer-letter',
      PatchCandidateOfferLetter: 'patch-candidate-offer-letter',
      GetAllCandiatesBoardView: 'candidates-board-view',
      DeleteCandidate: 'delete',
      RessignJob: 'ressignJob',
      GenarateOfferLetterLink: 'genarate-offer-letter-link',
      CandidateOfferLetterAndEmail: 'candidates-offer-letter-and-email',
      GetOfferLetterTemplatePath: 'get-offer-letter-template-path',
      GetOfferLetterHeader: 'get-offer-letter-header',
      GetCandidateDetailsById: 'get-all-candidate',
      GetPathForEmail: 'get-path-for-email',
      DeleteCandidateCheck: 'delete-candidate-check',
      AddPathEmail: 'get-path-candidate-email',
      AddPathMessage: 'get-path-message-candidate',
      GetMessageTemplate: 'get-message-template-candidate',
};
